(() => {
  const canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) return;

  const baseCanonical = new URL(canonicalLink.href);
  baseCanonical.search = '';
  baseCanonical.hash = '';

  const pageState = () => {
    const requestedPage = Number(new URL(location.href).searchParams.get('page'));
    const page = Number.isInteger(requestedPage) && requestedPage > 1 ? requestedPage : 1;
    const canonical = new URL(baseCanonical.href);
    if (page > 1) canonical.searchParams.set('page', String(page));
    return { canonical: canonical.href, page };
  };

  const syncPageSchema = (canonical, page) => {
    if (canonicalLink.href !== canonical) canonicalLink.href = canonical;

    const script = document.querySelector('script[data-netrition-schema="site"]');
    if (!script) return;
    let schema;
    try {
      schema = JSON.parse(script.textContent);
    } catch {
      return;
    }
    const graph = schema['@graph'];
    if (!Array.isArray(graph)) return;
    const collection = graph.find((node) => node['@type'] === 'CollectionPage');
    const breadcrumb = graph.find((node) => node['@type'] === 'BreadcrumbList');
    if (!collection || !breadcrumb) return;

    const breadcrumbId = `${canonical}#breadcrumb`;
    const itemListId = `${canonical}#itemlist-page-${page}`;
    const crumbs = breadcrumb.itemListElement;
    const lastCrumb = crumbs?.[crumbs.length - 1];
    if (collection['@id'] === `${canonical}#webpage` && collection.url === canonical &&
        collection.mainEntity?.['@id'] === itemListId && collection.breadcrumb?.['@id'] === breadcrumbId &&
        breadcrumb['@id'] === breadcrumbId && lastCrumb?.item === canonical) return;

    collection['@id'] = `${canonical}#webpage`;
    collection.url = canonical;
    collection.mainEntity = { '@id': itemListId };
    collection.breadcrumb = { '@id': breadcrumbId };
    breadcrumb['@id'] = breadcrumbId;
    if (lastCrumb) lastCrumb.item = canonical;
    script.textContent = JSON.stringify(schema);
  };

  const syncBoostCount = (page, cardCount) => {
    const header = document.querySelector('#boost-sd__collection-header .boost-sd__product-count');
    const pagination = document.querySelector('.boost-sd__product-count-pagination');
    const limitLabel = document.querySelector('.boost-sd__show-limit-list-button')?.textContent || '';
    const limit = Number(limitLabel.match(/Display:\s*(\d+)\s*per page/i)?.[1]);
    const range = pagination?.textContent.match(/Showing\s+(\d+)\s*-\s*(\d+)\s+of\s+\d+\s+products/i);
    if (!header || !range || !limit) return;
    const start = Number(range[1]);
    const end = Number(range[2]);
    if (start !== (page - 1) * limit + 1 || end - start + 1 !== cardCount) return;
    const text = pagination.textContent.trim();
    if (header.textContent.trim() !== text) header.textContent = text;
  };

  let lastSignature = '';
  const update = () => {
    if (document.querySelector('script[data-netrition-schema="collection-items"]')) return;
    const cards = [...document.querySelectorAll('.boost-sd__product-list > .boost-sd__product-item')];
    if (!cards.length) return;
    const items = cards.map((card) => {
      const link = card.querySelector('a.boost-sd__product-link[href*="/products/"]');
      const title = card.querySelector('.boost-sd__product-title')?.textContent?.trim();
      if (!link || !title) return null;
      const url = new URL(link.href, location.origin);
      url.search = '';
      url.hash = '';
      return { '@type': 'ListItem', position: 0, name: title, url: url.href };
    }).filter(Boolean);
    if (!items.length) return;
    items.forEach((item, index) => { item.position = index + 1; });
    const { canonical, page } = pageState();
    syncPageSchema(canonical, page);
    syncBoostCount(page, cards.length);
    const signature = JSON.stringify({ canonical, page, items });
    if (signature === lastSignature) return;
    lastSignature = signature;
    const existing = document.querySelector('script[data-netrition-schema="boost-collection-items"]');
    const node = existing || document.createElement('script');
    node.type = 'application/ld+json';
    node.dataset.netritionSchema = 'boost-collection-items';
    node.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      '@id': `${canonical}#itemlist-page-${page}`,
      numberOfItems: items.length,
      itemListElement: items
    });
    if (!existing) document.head.appendChild(node);
  };

  const start = () => {
    update();
    const observer = new MutationObserver(() => requestAnimationFrame(update));
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', update);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
